import React, { useEffect, useRef, useState } from 'react';
import './Highscores.styles.scss';
import SvgIcon from '../../components/svg-icon/svg-icon.component';
import mainApi from '../../redux/apis/main-api';
import Container from '../../components/layout/container.component';
import Countdown from '../../components/countdown/countdown.component';
import Button from '../../components/buttons/button.component';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/globals/globals.selectors';
import DateInput from '../../components/formComponents/DateInput.component';

const Highscores = () => {
	const [scores, setScores] = useState();
	const [filterData, setFilterData] = useState();
	const interval = useRef();
	const user = useSelector(selectUser);

	useEffect(() => {
		return () => {
			clearInterval(interval.current);
			interval.current = null;
		};
	}, []);

	useEffect(() => {
		if (typeof filterData === 'undefined') return;

		clearInterval(interval.current);
		interval.current = null;

		interval.current = setInterval(() => {
			getScores();
		}, 30000);

		getScores();

		return () => {
			clearInterval(interval.current);
		};
	}, [filterData]);

	const getScores = () => {
		mainApi.get('/APIS/getScores', { params: filterData }).then((res) => {
			// Handle new response format: {success: true, data: {...}}
			const scoresData = res.data?.data || res.data;
			setScores(scoresData);
		}).catch((err) => {
			console.error('Failed to fetch scores:', err);
			setScores({ allTime: [], dailyRows: [], weeklyRows: [] });
		});
	};

	useEffect(() => {
		if (!user) return;
		setFilterData({ ...filterData, selectedDate: new Date(user.today).toISOString().split('T')[0] });
	}, [user]);

	return (
		<>
			<div className="highscores">
				<Container>
					{/* <h2 className="title">Community </h2>
					<h2 className="subtitle">Highscores</h2> */}

					<div className="allScores">
						<div className="scores alltime">
							<div className="title">All time</div>
							<div className="list">
								{scores &&
									scores.allTime?.map((item, index) => (
										<div className="score" key={index}>
											<div className="wallet">
												{item.name || 'Anonymous'}
											</div>
											<div className="value">{item.highscore || 0}</div>
										</div>
									))}
								<div className="foot">
									<div className="top10">Top 10</div>
								</div>
							</div>
						</div>

						<div className="scores weekly">
							<div className="title">Weekly</div>
							{scores && <Countdown timestamp={scores.weeklyServerTimeRemaining} />}
							<div className="list">
								{scores &&
									scores.weeklyRows?.map((item, index) => (
										<div className="score" key={index}>
											<div className="wallet">
												{item.name || 'Anonymous'}
											</div>
											<div className="value">{item.highscore || 0}</div>
										</div>
									))}
								<div className="foot">
									<div className="top10">Top 10</div>
								</div>
							</div>
						</div>

						<div className="scores daily">
							<div className="title">
								Daily
								<span>
									<DateInput
										className="dailyFilter"
										value={filterData?.selectedDate}
										name="date"
										onValueChange={(e) => {
											setFilterData({ ...filterData, selectedDate: e.target.value });
										}}
									/>
								</span>
							</div>

							{scores && <Countdown timestamp={scores.dailyServerTimeRemaining} />}

							<div className="list">
								{scores &&
									scores.dailyRows?.map((item, index) => (
										<div className="score" key={index}>
											<div className="wallet">
												{item.name || 'Anonymous'}
											</div>
											<div className="value">{item.highscore || 0}</div>
										</div>
									))}
								<div className="foot">
									<div className="top10">Top 10</div>
								</div>
							</div>
						</div>
					</div>
					<div className="prizes">
						<div>Daily/weekly prizes available in White Rabbit Discord.</div>
						<a href="https://bit.ly/31iC9oK" target="_blank">
							<Button>
								<SvgIcon icon="discord" /> Join Discord
							</Button>
						</a>
					</div>
				</Container>
			</div>
		</>
	);
};

export default Highscores;
